import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  // root: {
  //   width: '100%',
  //   backgroundColor: theme.palette.font.white,
  //   borderRadius: '0.9375rem',
  //   border: '0.0625rem solid #e4e7eb',
  //   padding: '2.5rem 0 1.5rem 1.563rem',
  //   marginBottom: '1.875rem',
  // },
  root: {
    height: '3rem',
    borderRadius: '0.625rem',
    backgroundColor: theme.palette.primary.main,
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    color: theme.palette.font.white,
    fontWeight: '500',
    marginRight: '1.563rem',
    textTransform: 'inherit',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  primary: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.font.white,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  green: {
    backgroundColor: '#00ab55',
    color: theme.palette.font.white,
    '&:hover': {
      backgroundColor: '#00ab55',
    },
  },
  yellow: {
    backgroundColor: '#FFFF00',
    color: '#000000',
    '&:hover': {
      backgroundColor: '#FFFF00',
    },
  },
}));

const CustomButton = (props) => {
  const classes = useStyles();
  const { children, buttonColor = 'primary', ...rest } = props;
  return (
    <Button {...rest} className={`${classes.root} ${classes[buttonColor]}`}>
      {children}
    </Button>
  );
};

export default CustomButton;
